import { jsx as _jsx } from "react/jsx-runtime";
import { ApiProvider } from '@/context/ApiContext';
import { AuthProvider } from '@/context/AuthContext';
import { SpellsProvider } from '@/context/SpellsContext';
export const Providers = ({ children }) => (_jsx(ApiProvider, { children: _jsx(AuthProvider, { children: _jsx(SpellsProvider, { children: children }) }) }));
